import React from "react";

const TransactionImg = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_97_2055)">
        <path
          d="M14.2002 11.966L15.7502 10.416L14.2002 8.86597"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 10.416H15.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.79999 13.2577L8.25 14.8077L9.79999 16.3577"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 14.8076H8.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g clipPath="url(#clip1_97_2055)">
        <path
          d="M14.2002 11.966L15.7502 10.416L14.2002 8.86597"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 10.416H15.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.79999 13.2577L8.25 14.8077L9.79999 16.3577"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 14.8076H8.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M12 22.6118C17.5228 22.6118 22 18.1346 22 12.6118C22 7.08897 17.5228 2.61182 12 2.61182C6.47715 2.61182 2 7.08897 2 12.6118C2 18.1346 6.47715 22.6118 12 22.6118Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0_97_2055">
          <rect
            width="10"
            height="10"
            fill={color}
            transform="translate(7 7.61182)"
          />
        </clipPath>
        <clipPath id="clip1_97_2055">
          <rect
            width="10"
            height="10"
            fill={color}
            transform="translate(7 7.61182)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TransactionImg;
